const initialControlState = {
    loading: false,
    IsGeral: true,
    allowEdit: false,
    activeModalComands : false,
    activeModalAlarms : false,
    activeModalCode: false,
    sendingCode: false,
    showCaption: false,
    lastUpdate : {
        date: '',
        day: '',
        hour: '',
    },
    EquipamentsList: [],
    Equipament: null,
    layoutsList: [],
    layout:{
        id: null,
        name: null,
    },
    comands:[],
    data: [],
    alarms: {
        'name': null,
        'alarmHH': null,
        'alarmH': null,
        'alarmLL': null,
        'alarmL': null,
    },
    cards:{
        id: null,
        name : null,
        cards: [],
    },
    time: 120,
    GraphData: {
        dados: [
            {
                id: '',
                data: []
            }
        ],
        max: 0,
        min: 0,
    },
    cities: [],
    city: '',
    isTuorActive: false,
}

export default function controlReducer (PrevState = initialControlState, action ){
    switch (action.type) {
        case 'ChangeEquipamentList':
            return{
                ...PrevState,
                EquipamentsList: action.payload.Equipaments
            };
        case 'ChangeLayout':
            return{
                ...PrevState,
                layout:{
                    id : action.payload.id,
                    name: action.payload.name,
                }
            };
        case 'ChangeData':
            return{
                ...PrevState,
                data : action.payload.data,
            };
        case 'ChangeLayoutsList':
            return{
                ...PrevState,
                layoutsList: action.payload.layoutsList
            };
        case 'ChangeComand':
            return{
                ...PrevState,
                comands: action.payload.comands
            };
        case 'RemoveComand':
            return{
                ...PrevState
            };
        case 'ChangeEdit':
            return{
                ...PrevState,
                allowEdit: action.payload.allowEdit
            };
        case 'ChangeLoading':
            return{
                ...PrevState,
                loading: action.payload.loading
            };
        case 'ChangeControlShowCaption':
            return{
                ...PrevState,
                showCaption : action.payload.showCaption
            };
        case 'ChangeModalCode':
            return{
                ...PrevState,
                activeModalCode: action.payload.activeModalCode
            };
        case 'sendingCode':
            return{
                ...PrevState,
                sendingCode: action.payload.sendingCode
            };  
        case 'ChangeLastUpdate':
            return{
                ...PrevState,
                lastUpdate: action.payload.lastUpdate
            };
        case 'ChangeModalComands':
            return{
                ...PrevState,
                activeModalComands : action.payload.activeModalComands,
            };
        case 'ChangeAlarms' :
            return{
                ...PrevState,
                alarms : action.payload.alarms
            };
        case 'ChangeModalAlarms':
            return{
                ...PrevState,
                activeModalAlarms : action.payload.activeModalAlarms,
            };
        case 'showDetails':
            return{
                ...PrevState,
                IsGeral: action.payload.IsGeral
            };
        case 'ChangeCards':
            return{
                ...PrevState,
                cards : action.payload.cards
            };
        case 'ChangeGraphData':
            return{
                ...PrevState,
                GraphData: action.payload.GraphData
            };
        case 'ChangeTime':
            return{
                ...PrevState,
                time: action.payload.time
            };
        case 'ChangeControlCities':
            return{
                ...PrevState,
                cities: action.payload.cities
            };
        case 'ChangeControlCity':
            return{
                ...PrevState,
                city: action.payload.city
            }
        case 'ChangeControlTourActive':
            return{
                ...PrevState,
                isTuorActive: action.payload.isTuorActive
            }
        default:
            return PrevState;
    }
}